import { Department, RequirementFactory } from '../../types/data';
import { Report } from '../../types/table';
import { calculateIndentColumn } from '../../utils/utils';

const COLUMNS = {
  '1': {
    width: '93px',
    indent: '0',
  },
  '2': {
    width: '93px',
    indent: '93px',
  },
  '3': {
    width: '93px',
    indent: '186px',
  },
  '4': {
    width: '170px',
    indent: '279px',
  },
  '5': {
    width: '100px',
    indent: '0',
    indentFactory: '300px',
    indentRegion: '200px',
  },
  '6': {
    width: '76px',
    indent: '100px',
    indentFactory: '400px',
    indentRegion: '300px',
  },
  '7': {
    width: '350px',
    indent: '176px',
    indentFactory: '476px',
    indentRegion: '376px',
  },
  '8': {
    width: '120px',
    indent: '526px',
    indentRegion: '726px',
  },
};

type TableHeadProps = {
  category: Report;
  data: Department[] | RequirementFactory[];
  isFixed?: boolean;
};

function TableHead({ category, data, isFixed }: TableHeadProps) {
  return (
    <thead className={`${isFixed && 'sticky top-[-1px] z-20'} bg-white`}>
      <tr>
        {(category === 'factory' || category === 'region') && (
          <>
            <th
              className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black`}
              style={{
                left: COLUMNS['1'].indent,
                width: `${COLUMNS['1'].width}`,
              }}
            >
              Год
            </th>
            <th
              className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black`}
              style={{
                left: COLUMNS['2'].indent,
                width: `${COLUMNS['2'].width}`,
              }}
            >
              Месяц
            </th>

            {category === 'factory' && (
              <>
                <th
                  className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black`}
                  style={{
                    left: COLUMNS['3'].indent,
                    width: `${COLUMNS['3'].width}`,
                  }}
                >
                  Завод
                </th>

                <th
                  className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black`}
                  style={{
                    left: COLUMNS['4'].indent,
                    width: `${COLUMNS['4'].width}`,
                  }}
                >
                  Колонна/Блок
                </th>
              </>
            )}
          </>
        )}

        {category !== 'factory' && (
          <>
            <th
              className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black`}
              style={{
                left: calculateIndentColumn(category, COLUMNS['5']),
                width: `${COLUMNS['5'].width}`,
              }}
            >
              Процесс
            </th>
            <th
              className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black`}
              style={{
                left: calculateIndentColumn(category, COLUMNS['6']),
                width: `${COLUMNS['6'].width}`,
              }}
            >
              Уровень зрелости
            </th>
            <th
              className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black`}
              style={{
                left: calculateIndentColumn(category, COLUMNS['7']),
                width: `${COLUMNS['7'].width}`,
              }}
            >
              Требование
            </th>
          </>
        )}

        {(category === 'region' || category === 'default') && (
          <th
            className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black`}
            style={{
              left: calculateIndentColumn(category, COLUMNS['8']),
              width: `${COLUMNS['8'].width}`,
            }}
          >
            Показатель процесса
          </th>
        )}

        {data.map((el) => (
          <th
            key={el.id || el.ID}
            className="relative w-[105px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black before:absolute before:top-0 before:right-[-1px] before:h-full before:w-[1px] before:bg-gray-400"
          >
            {'shortTitle' in el && (category === 'region' || category === 'default')
              ? el.shortTitle
              : el.title}
          </th>
        ))}

        {category !== 'region' && (
          <>
            <th className="relative w-[116px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
              Среднее по производствам
            </th>
            <th className="relative w-[116px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
              Среднее по заводу
            </th>
          </>
        )}

        {category === 'region' && data.length > 1 && (
          <th className="relative w-[116px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
            Среднее по региону
          </th>
        )}

        {category === 'factory' && (
          <>
            <th className="relative w-[148px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
              Кто завершил оценку
            </th>

            <th className="relative w-[148px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
              Дата завершения
            </th>
          </>
        )}
      </tr>
    </thead>
  );
}

export default TableHead;
